import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/shared/services/analytics/analytics.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  yearsOfExperience = new Date().getFullYear() - 2019;

  constructor(public analyticsService: AnalyticsService) {}

  ngOnInit(): void {}

  interpolateYears(text: string): string {
    return text.replace(/\{\{\s*years\s*\}\}/g, String(this.yearsOfExperience));
  }
}
